const contactDetails = [
  {
    label: 'Address',
    value: '122 Edinadeseti Dekemvri str.',
    icon: 'ri-map-pin-line',
  },
  {
    label: 'City',
    value: 'Byala',
    icon: 'ri-building-line',
  },
  {
    label: 'Zip',
    value: '7100',
    icon: 'ri-mail-open-line',
  },
  {
    label: 'Country',
    value: 'Bulgaria',
    icon: 'ri-global-line',
  },
  {
    label: 'Email',
    value: 'contact@darleeood.com',
    icon: 'ri-at-line',
  },
  {
    label: 'Number',
    value: '+1 6627324136',
    icon: 'ri-phone-line',
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-gray-50 py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 mb-16 md:mb-24">
          <div>
            <div className="inline-flex items-center border border-gray-300 rounded-full px-5 py-1.5 mb-8">
              <span className="text-xs font-semibold tracking-widest uppercase text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
                Contact
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              Get In Touch
              <br />
              <span className="font-light text-gray-400">With Our Team</span>
            </h2>
          </div>
          <p className="text-base text-gray-500 max-w-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Have questions about our iOS applications? Reach out to us — we are always happy to help.
          </p>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Contact Info */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white rounded-2xl p-8 md:p-10 border border-gray-100">
              <h3 className="text-lg font-bold text-gray-900 mb-8" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                Contact Information
              </h3>
              <ul className="flex flex-col gap-6">
                {contactDetails.map((detail) => (
                  <li key={detail.label} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-50 flex-shrink-0 mt-0.5">
                      <i className={`${detail.icon} text-gray-500 text-lg`} />
                    </div>
                    <div>
                      <span className="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>
                        {detail.label}
                      </span>
                      <span className="text-base font-medium text-gray-800" style={{ fontFamily: "'Inter', sans-serif" }}>
                        {detail.value}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Map / Visual */}
          <div className="w-full lg:w-1/2 flex flex-col gap-8">
            {/* Location Card */}
            <div className="relative rounded-2xl overflow-hidden h-64 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/3de505b6cdb1cf3735b4361344c74e25.jpg"
                alt="Byala, Bulgaria"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <p className="text-white font-bold text-lg" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Byala, Bulgaria</p>
                <p className="text-white/70 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>122 Edinadeseti Dekemvri str., 7100</p>
              </div>
            </div>

            {/* Company Tagline */}
            <div className="bg-gray-950 rounded-2xl p-8 flex flex-col gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10">
                <i className="ri-apple-fill text-white text-xl" />
              </div>
              <h4 className="text-xl font-bold text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                COMPANY
              </h4>
              <p className="text-sm text-white/50 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                A team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Bar */}
        <div className="mt-16 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; 2026 COMPANY. All rights reserved.
          </p>
          <p className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
            iOS App Development &mdash; Byala, Bulgaria
          </p>
        </div>
      </div>
    </section>
  );
}
